import React, { useState, useEffect} from 'react';

import { Box, Button, Container}  from '@mui/material';

import { ChevronRight, Delete} from '@mui/icons-material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from "@mui/material/TableCell";
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import * as Config from '../Config.js'; 

import TopAppBar from './TopAppBar' ;
import { useTranslation } from "react-i18next";
import { useNavigate} from 'react-router-dom';


const FriendsScreen = (props) => {   
    const navigate = useNavigate();
    const { t } = useTranslation();
    
    const [requests, setRequests] = useState([]) ;
    const [friends, setFriends] = useState([]) ;
    
    
    const listFriendRequests = () => {            
        console.log('listFriendRequests') ;
        

        fetch(Config.apiUrl  + '/site/friendrequests',  {
            credentials: 'include'
        })
        .then(response => response.json())
        .then( (res) => {
            if (res.success) {
                console.log('gotFriends and requests') ;
                setRequests(res.requests) ;
                setFriends(res.friends) ;

            } else {
                navigate('/') ;
            }
        })
    }
    
    useEffect(() => { 
        console.log('useeffect invoked') ;
        listFriendRequests() ;
    // the next line prevents the useEffect excessive warning
    // eslint-disable-next-line react-hooks/exhaustive-deps    
    },[]) 
    
    
    // this function is duplicated => create component helper => NOT EASY because use_navigate
    const manageFriend = (mode, id_friend) => {
        
        const data = new FormData();
        data.append('mode', mode);
        data.append('id_friend', id_friend);

        fetch(Config.apiUrl  + '/site/managefriend',  {
            method: 'POST',
            credentials: 'include', 
            body: data,
        })
        .then(response => response.json())
        .then( (res) => {
            if (res.success) {
                listFriendRequests()  ;
            } else {
                 navigate('/') ;
            }
        })
    }
   
    
   
    return(
        <Container maxWidth="sm" >
            <TopAppBar 
                title={t('My Friends')} 
                returnLink={"/"}
            />
            <Box textAlign = "center" marginTop = "5%">
                <Button 
                    onClick={() => navigate('/askforfriend')}
                    variant="outlined"
                    endIcon={<ChevronRight />}
                    >{t("Make a friend request")}
                </Button>
            </Box>
        { requests.length > 0   &&
            <Box textAlign = "center" marginTop = "5%" marginBottom="5%">    
                <Button 
                    onClick={() => navigate('/friendrequests')}
                    variant="outlined"
                    endIcon={<ChevronRight />}
                    >{t("You have friend requests")}
                </Button>
            </Box>
        }
        
        
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 200}}>     
        
                <TableBody>
                    {friends.map((usr, i) => 
                        <TableRow
                        key={i}
                        >
                            <TableCell component="th" scope="row" sx={{fontWeight: 'bold'}}>
                              {usr.name}
                            </TableCell>
                            <TableCell align="right">
                                <Button 
                                    color = "error"
                                    endIcon = {<Delete color="error"/>}
                                    onClick={() => manageFriend('reject', usr.id)}
                                    variant="outlined"
                                >
                                </Button>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
        </Container>
    );
    
}

export default FriendsScreen ;